import React from "react";
import { Grid } from "@mui/material";
import "../styles/Section1.css";
import icon1 from "../assets/Icons/Group.png";
import icon2 from "../assets/Icons/Octicon.png";
import icon3 from "../assets/Icons/Money.png";
import icon4 from "../assets/Icons/Pencil.png";

const Works = () => {
  const workSteps = [
    {
      icon: icon1,
      title: "Create or Join a Group",
      description:
        "Start by creating a new savings group or join an existing one. Invite friends, family, or trusted individuals to your group.",
    },
    {
      icon: icon2,
      title: "Set Your Goals",
      description:
        "Decide on a monthly contribution and set a collective financial target with your group.",
    },
    {
      icon: icon3,
      title: "Receive Funds",
      description:
        "Every month, one member receives the total contributions. Order is set by the admin or randomly by D'Ajoo.",
    },
    {
      icon: icon4,
      title: "Track and Manage",
      description:
        "Monitor your group’s progress, manage contributions, and receive notifications about payouts and contributions",
    },
  ];

  return (
    <Grid
      container
      spacing={4}
      sx={{
        mt: 0,
        backgroundColor: "#52057B",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: "60px",
        paddingTop: "30px",
      }}
      className="work-se"
    >
      <Grid item sm={10}>
        <Grid container spacing={4}>
          <Grid item xs={12} sx={{ marginBottom: "50px" }}>
            <div className="work-heading">How It Works</div>
          </Grid>
          {workSteps.map((step, index) => (
            <Grid item xs={12} sm={3} key={index}>
              <div className="icon">
                <img alt="icon" src={step.icon} />
              </div>
              <div className="work-lebel">{step.title}</div>
              <div className="work-text">{step.description}</div>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Works;
